'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Image from 'next/image';

const LighthouseLogo = () => (
  <Image
    src="/assets/images/Final_999-1784238813500.png"
    alt="Harbour Counselling Practice Logo"
    width={120}
    height={56}
    className="object-contain"
    priority
  />
);

const navLinks = [
  { href: '/', label: 'Home' },
  { href: '/about', label: 'About' },
  { href: '/services', label: 'Services' },
  { href: '/fees', label: 'Fees' },
  { href: '/resources', label: 'Resources' },
  { href: '/faqs', label: 'FAQs' },
  { href: '/contact', label: 'Contact' },
];

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link href="/" className="flex items-center gap-3 flex-shrink-0">
            <LighthouseLogo />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {navLinks?.map((link) => (
              <Link
                key={link?.href}
                href={link?.href}
                className={`text-sm font-medium transition-colors duration-200 ${
                  pathname === link?.href
                    ? 'text-[#1B4D4A] border-b-2 border-[#1B4D4A] pb-0.5'
                    : 'text-gray-600 hover:text-[#1B4D4A]'
                }`}
              >
                {link?.label}
              </Link>
            ))}
          </nav>

          {/* Book Button */}
          <div className="hidden lg:block">
            <Link
              href="/book"
              className="bg-[#1B4D4A] text-white px-5 py-2.5 rounded-lg text-sm font-medium hover:bg-[#2A6B67] transition-colors duration-200"
            >
              Book a Session
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="lg:hidden p-2 text-gray-600"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden border-t border-gray-100 py-4">
            <nav className="flex flex-col gap-3">
              {navLinks?.map((link) => (
                <Link
                  key={link?.href}
                  href={link?.href}
                  onClick={() => setMenuOpen(false)}
                  className={`text-sm font-medium px-2 py-1.5 rounded transition-colors ${
                    pathname === link?.href
                      ? 'text-[#1B4D4A] bg-[#E8F0EF]'
                      : 'text-gray-600 hover:text-[#1B4D4A] hover:bg-[#E8F0EF]'
                  }`}
                >
                  {link?.label}
                </Link>
              ))}
              <Link
                href="/book"
                onClick={() => setMenuOpen(false)}
                className="bg-[#1B4D4A] text-white px-5 py-2.5 rounded-lg text-sm font-medium text-center mt-2 hover:bg-[#2A6B67] transition-colors"
              >
                Book a Session
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
